import { useState, useEffect } from 'react';
import API_ROUTES from './apiRoutes';
import { useFetch } from './useFetch';

export const useContentDetails = ({ serieId }) => {
    const [headerContent, setHeaderContent] = useState(null);
    const [episodes, setEpisodes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { fetchWithAuth } = useFetch();

    const getToken = () => localStorage.getItem("token");

    useEffect(() => {
        const fetchSerieDetails = async () => {
            try {
                setLoading(true);
                const response = await fetchWithAuth(`${API_ROUTES.SERIES.get(serieId)}`, {
                    method: 'GET',
                    headers: {
                        "Authorization": `Bearer ${getToken()}`,
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch serie details');
                }

                const data = await response.json();
                const serie = data.serie.serie;

                // Transform header content
                const headerData = {
                    id: serie.serie_id,
                    title: serie.serie_title,
                    subtitle: serie.serie_subtitle,
                    description: serie.serie_description,
                    thumbnailUrl: serie.serie_thumbnail_url,
                    status: serie.serie_is_blocked ? 'blocked' : 'available',
                    salesPage: serie.content_template_id
                };
                setHeaderContent(headerData);

                // Transform episodes

                console.log(serie.serie_episodes);
                const transformedEpisodes = serie.serie_episodes
                    .sort((a, b) => a.episode_index - b.episode_index)
                    .map(episode => ({
                        contentId: episode.episode_content.content_id,
                        title: episode.episode_content.content_title,
                        subtitle: episode.episode_content.content_subtitle,
                        description: episode.episode_content.content_description,
                        thumbnailUrl: episode.episode_content.content_thumbnail_url,
                        status: episode.episode_content.content_is_blocked ? 'blocked' : 'available',
                        salesPage: episode.episode_content.content_template_id,
                        url: episode.episode_content.content_url,
                        additionalInfo: episode.episode_content.content_additional_info,
                        access: episode.episode_content.content_access
                    }));
                setEpisodes(transformedEpisodes);
                setError(null);
            } catch (err) {
                setError(err.message);
                setHeaderContent(null);
                setEpisodes([]);
            } finally {
                setLoading(false);
            }
        };

        if (serieId) {
            fetchSerieDetails();
        }
    }, [serieId]);

    return {
        headerContent,
        episodes,
        loading,
        error
    };
};
